import React from 'react';

const tabs = [
  { id: 'setup', label: 'Evento' },
  { id: 'banking', label: 'Cobros' },
  { id: 'overview', label: 'Resumen' },
  { id: 'gifts', label: 'Mi lista' },
  { id: 'received', label: 'Regalos' },
  { id: 'security', label: 'Seguridad' },
];

const DashboardTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="bg-white border-b border-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8 overflow-x-auto">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`py-4 px-2 border-b-2 font-medium whitespace-nowrap transition-colors ${
                activeTab === tab.id
                  ? 'border-accent-500 text-accent-600'
                  : 'border-transparent text-neutral-500 hover:text-neutral-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardTabs;